export const LISTERI_RED = '#f73f21'
